import { render, staticRenderFns } from "./BusinessPersonalCenter.vue?vue&type=template&id=3e3d3a36&scoped=true"
import script from "./BusinessPersonalCenter.vue?vue&type=script&lang=js"
export * from "./BusinessPersonalCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3d3a36",
  null
  
)

export default component.exports